import { ChangeDetectionStrategy, Component, HostBinding, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslationKeys } from '@nimbus-library/features/localization/models/enums/translation-keys.enum';
import { AdministrationGroupViewModel } from '@nimbus-library/features/shared/components/material/input-administration-security-group/models/administration-group.view-model';

@Component({
  standalone: false,
  selector: 'nimbus-security-group-info',
  templateUrl: './security-group-info.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SecurityGroupInfoComponent {
  @HostBinding('class')
  public class: string = 'nimbus-material-popup form-popup';

  public readonly TranslationKeys = TranslationKeys;

  public constructor(
    private dialogReference: MatDialogRef<SecurityGroupInfoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AdministrationGroupViewModel,
  ) {}

  public close(): void {
    this.dialogReference.close();
  }
}
